import columns from '../../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavigationProps(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.MULTIPLE_PREDES_DETAILS.id,
    mainReportId: ReportDefinitions.MULTIPLE_PREDES_SUMMARY.id,
    requestParams: {
      impcFrom: rowInfo.row['originImpc'],
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Origin IMPC operator', 'originImpcOperator'),
        new TextColumn('Origin IMPC', 'originImpc'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new NavigationColumn(new NonZeroNumberColumn('Despatches', 'despatches'), getDetailsTabNavigationProps),
        new NonZeroNumberColumn('PREDES messages', 'predesMessages'),
      ],
    },
    {
      Header: 'Messages per despatch',
      columns: [
        new NonZeroNumberColumn('Maximum', 'messagesPerDespatch.maximum'),
        new NonZeroNumberColumn('Median', 'messagesPerDespatch.median'),
      ],
    },
    {
      Header: 'Message count per change type',
      columns: [
        new NonZeroNumberColumn('Receptacles added', 'messageCountPerChangeType.receptaclesAdded'),
        new NonZeroNumberColumn('Receptacles removed', 'messageCountPerChangeType.receptaclesRemoved'),
        new NonZeroNumberColumn('Items added', 'messageCountPerChangeType.itemsAdded'),
        new NonZeroNumberColumn('Items removed', 'messageCountPerChangeType.itemsRemoved'),
        new NonZeroNumberColumn('Weight changed', 'messageCountPerChangeType.weightChanged'),
        new NonZeroNumberColumn('AMSC changed', 'messageCountPerChangeType.amscChanged'),
        new NonZeroNumberColumn('Transport changed', 'messageCountPerChangeType.transportChanged'),
      ],
    },
  ];
};
